var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9993 19.3333H21.3327L20.3961 18.3967C20.1421 18.1427 19.9993 17.7982 19.9993 17.439V15.3333C19.9993 13.5917 18.8863 12.1101 17.3327 11.5609V11.3333C17.3327 10.597 16.7357 10 15.9993 10C15.263 10 14.666 10.597 14.666 11.3333V11.5609C13.1124 12.1101 11.9993 13.5917 11.9993 15.3333V17.439C11.9993 17.7982 11.8566 18.1427 11.6026 18.3967L10.666 19.3333H13.9993M17.9993 19.3333V20C17.9993 21.1046 17.1039 22 15.9993 22C14.8948 22 13.9993 21.1046 13.9993 20V19.3333M17.9993 19.3333H13.9993",
    stroke: "#4D6276",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#D1D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.b79505bf48256feb2421a77aedc0c0cd.svg";
export { ForwardRef as ReactComponent };